import { useMemo } from 'react';
import { useField } from 'formik';

import { DataExtractionPrompt } from './data-extraction-prompt';
import { PostCallPrompt } from './post-call-prompt';
import { SentimentPrompt } from './sentiment-prompt';

export const PostCall = () => {
  const [promptVarsField] = useField<string[]>('prompt_variables');

  const promptVariables = useMemo(
    () => (promptVarsField.value?.filter(Boolean) ?? []) as string[],
    [promptVarsField.value]
  );

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h3 className="text-base font-semibold">Summary</h3>
        <p className="text-sm text-muted-foreground">
          Configure how call transcripts are analyzed and summarized (Required)
        </p>
      </div>

      <PostCallPrompt
        title="Summary analysis"
        description="Configure how call transcripts are summarized after each conversation"
        required
        name="summary_prompt"
        variablesName="summary_prompt_variables"
        promptVariables={promptVariables}
      />

      <div className="space-y-6 pt-6 border-t">
        <div className="space-y-2">
          <h3 className="text-base font-semibold">Data Extraction</h3>
          <p className="text-sm text-muted-foreground">
            Define custom data specifications to extract from conversation transcripts (Optional)
          </p>
        </div>

        <DataExtractionPrompt promptVariables={promptVariables} />
      </div>

      <div className="space-y-6 pt-6 border-t">
        <div className="space-y-2">
          <h3 className="text-base font-semibold">Sentiment</h3>
          <p className="text-sm text-muted-foreground">
            Classify caller sentiment using tags tailored to your use case (Required)
          </p>
        </div>

        <SentimentPrompt promptVariables={promptVariables} />
      </div>
    </div>
  );
};
